import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Grid } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import makeValidationSchema from './ConsignmentDetailsMakeValidationSchema'

const {
  form: {
    field: {
      CngTextField,
      CngCodeMasterAutocompleteField
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  id: null,
  billNo: "",
  parentBillNo: "",
  locationIdentificationType: "",
  consignmentLocation: "",
  consignmentLocationName: "",
  terminalPierName: "",
  monetaryAmountType: "",
  monetaryAmount: "",
  currencyCode: "",
  chargeCategoryCode: "",
  paymentArrangementCode: ""
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled }) {
  const { setValue } = useFormContext()
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const t = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let locationIdentificationType = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.LOCATION_IDENTIFICATION_TYPE)
    let consignmentLocation = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.CONSIGNMENT_LOCATION)
    let consignmentLocationName = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.CONSIGNMENT_LOCATION_NAME)
    let terminalPierName = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.TERMINAL_PIER_NAME)
    let monetaryAmountType = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.MONETARY_AMOUNT_TYPE)
    let monetaryAmount = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.MONETARY_AMOUNT)
    let currencyCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.CURRENCY_CODE)
    let chargeCategoryCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.CHARGE_CATEGORY_CODE)
    let paymentArrangementCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.PAYMENT_ARRANGEMENT_CODE)

    return {
      locationIdentificationType, consignmentLocation, consignmentLocationName,
      terminalPierName, monetaryAmountType, monetaryAmount,
      currencyCode, chargeCategoryCode, paymentArrangementCode
    }
  }

  return (
    <Grid container spacing={1}>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          required
          name="locationIdentificationType"
          label={t.locationIdentificationType}
          disabled={disabled}
          codeType='UAE_MPCI_CONSIGNMENT_LOC_TYPE'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          required
          name="consignmentLocation"
          label={t.consignmentLocation}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 6 }}
          onChange={(e) => setValue("consignmentLocation", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="consignmentLocationName"
          label={t.consignmentLocationName}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 256 }}
          onChange={(e) => setValue("consignmentLocationName", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="terminalPierName"
          label={t.terminalPierName}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 70 }}
          onChange={(e) => setValue("terminalPierName", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="monetaryAmountType"
          label={t.monetaryAmountType}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 3 }}
          onChange={(e) => setValue("monetaryAmountType", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="monetaryAmount"
          label={t.monetaryAmount}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 35 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="currencyCode"
          label={t.currencyCode}
          disabled={disabled}
          codeType='UAE_MPCI_CURRENCY'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="chargeCategoryCode"
          label={t.chargeCategoryCode}
          disabled={disabled}
          codeType='UAE_MPCI_CHARGE_CATEGORY'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="paymentArrangementCode"
          label={t.paymentArrangementCode}
          disabled={disabled}
          codeType='UAE_MPCI_PAYMENT_ARRANGEMENT'
          size='small'
        />
      </CngGridItem>
    </Grid>
  )
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default FormProperties
